import api from "./api";

export const EMPTY_CROSS_CONNECTION = Object.freeze({
  hasOtherActive: false,
  others: [],
  lastClosed: null,
});

export async function fetchCrossConnectionStatus(ticketIds, { timeout = 10000 } = {}) {
  const ids = (ticketIds || []).map(Number).filter((n) => Number.isInteger(n) && n > 0);
  if (ids.length === 0) return {};
  const { data } = await api.post(
    "/tickets/cross-connection-status",
    { ticketIds: ids },
    { timeout }
  );
  return data || {};
}
